const throttle = (fn, delay) => {
	let timeout = null;
	return (...args) => {
		if (!timeout) {
			timeout = setTimeout(() => {
				timeout = null;
				fn(...args);
			}, delay);
		}
	};
}

export { throttle };